import { Stack, useTheme } from "@mui/material";
import { SubNavAppBar } from "components/AppBar";
import { WasteDateRangePicker } from "components/WasteDateRangePicker";

type Props = {
  shipDateStart?: string;
  shipDateEnd?: string;
  onChange: (next: { shipDateStart?: string; shipDateEnd?: string }) => void;
};

export function TenantWasteStreamsDateFilter({ shipDateStart, shipDateEnd, onChange }: Props) {
  const theme = useTheme();

  return (
    <SubNavAppBar
      sx={{
        py: 2,
        px: 3,
        borderBottom: "1px solid",
        borderColor: theme.palette.divider,
      }}
    >
      <Stack direction={{ xs: "column", md: "row" }} alignItems="start" spacing={2}>
        <WasteDateRangePicker
          startDate={shipDateStart}
          endDate={shipDateEnd}
          onAccept={(next) =>
            onChange({ shipDateStart: next.startDate, shipDateEnd: next.endDate })
          }
        />
      </Stack>
    </SubNavAppBar>
  );
}
